import App from 'app/app.js';

function LtFormChangeDirective($parse) {
  return {
    restrict: 'A',
    require: 'form',
    link: function (scope, element, attrs) {
      var cb = $parse(attrs.ltFormChange);
      element.on('change', function () {
        cb(scope);
      });
    }
  };
}

App.directive('ltFormChange', ['$parse', LtFormChangeDirective]);
